import { render } from "./ViewOptionsModal.vue?vue&type=template&id=045f32d4"
import script from "./ViewOptionsModal.vue?vue&type=script&lang=js"
export * from "./ViewOptionsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__